import React from 'react';

const DownloadFileImage = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={props.width || 22}
      height={props.height || 25}
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.75 2.5H9.25C9.66562 2.5 10 2.83437 10 3.25V8.5H12.7406C13.2969 8.5 13.575 9.17188 13.1812 9.56563L8.42813 14.3219C8.19375 14.5562 7.80937 14.5562 7.575 14.3219L2.81562 9.56563C2.42188 9.17188 2.7 8.5 3.25625 8.5H6V3.25C6 2.83437 6.33437 2.5 6.75 2.5ZM16 14.25V17.75C16 18.1656 15.6656 18.5 15.25 18.5H0.75C0.334375 18.5 0 18.1656 0 17.75V14.25C0 13.8344 0.334375 13.5 0.75 13.5H5.33437L6.86562 15.0312C7.49375 15.6594 8.50625 15.6594 9.13437 15.0312L10.6656 13.5H15.25C15.6656 13.5 16 13.8344 16 14.25ZM12.125 17C12.125 16.6562 11.8438 16.375 11.5 16.375C11.1562 16.375 10.875 16.6562 10.875 17C10.875 17.3438 11.1562 17.625 11.5 17.625C11.8438 17.625 12.125 17.3438 12.125 17ZM14.125 17C14.125 16.6562 13.8438 16.375 13.5 16.375C13.1562 16.375 12.875 16.6562 12.875 17C12.875 17.3438 13.1562 17.625 13.5 17.625C13.8438 17.625 14.125 17.3438 14.125 17Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DownloadFileImage;
